import { assetsService as e } from "./AssetsService.js";
import { authService as r } from "./AuthService.js";
import { serverService as i } from "./ServerService.js";
import { utilsService as s } from "./UtilsService.js";
import { itemsService as t } from "./ItemsService.js";
import { filesService as m } from "./FilesService.js";
const a = {
  assets: e,
  auth: r,
  server: i,
  utils: s,
  items: t,
  files: m
};
export {
  a as services
};
